var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('LoginLogout'),_c('div',[_c('img',{attrs:{"src":_vm.$auth.user.picture}}),_c('h2',[_vm._v(_vm._s(_vm.$auth.user.name))])]),_c('div',[_c('pre',[_vm._v(_vm._s(JSON.stringify(_vm.$auth.user, null, 2)))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }